import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import EmploymentStatusViewModel from '../ViewModels/EmploymentStatusViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IEmploymentStatusDropDownProps {
    setEmploymentStatus?: (event) => void;
    employmentStatus: string | undefined;
    disabled: boolean;
}

interface IEmploymentStatusDropDownState {
    model: EmploymentStatusViewModel[];
    loaded: boolean;
}

class EmploymentStatusDropDown extends Component<IEmploymentStatusDropDownProps & WithStyles<typeof styles>, IEmploymentStatusDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetEmploymentStatus').then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultEmploymentStatusVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label="What were/are you doing before your course starts?"
                name="employmentStatus"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.employmentStatus}
                onChange={this.props.disabled ? undefined : this.props.setEmploymentStatus}
                disabled={this.props.disabled}
                validators={['required']}
                errorMessages={['This field is required']}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(EmploymentStatusDropDown);